module.exports = __webpack_public_path__ + "static/media/calendarIcon.c8ef39b1.svg";